import React from 'react'

import {
    GridContainer,
    GridItem2,
    GridItem3,
    GridItem6,
    GridItem8,
} from '../../../business-components/Grid/Grid'

import {
    IdadeInicial,
    IdadeFinal,
    Mes,
    AporteAnual,
    RetiradaAnual,
    Observacao,
} from './SimulacaoFinanceiraCompAporteRetiradaAnual'



const SimulacaoFinanceiraFormAporteRetiradaAnualConfiguracao = ({ values, ind, item, handleChange }) => {

    return (
        <>
            <GridContainer>
                <GridItem3>
                    <GridContainer>
                        <GridItem6>
                            <IdadeInicial
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                        <GridItem6>
                            <IdadeFinal
                                values={values}
                                item={item}
                                ind={ind}
                                handleChange={handleChange}
                            />
                        </GridItem6>
                    </GridContainer>
                </GridItem3>
                <GridItem2>
                    <Mes
                        item={item}
                        ind={ind}
                        handleChange={handleChange}
                    />
                </GridItem2>
                <GridItem3>
                    <AporteAnual
                        item={item}
                        ind={ind}
                        handleChange={handleChange}
                    />
                </GridItem3>
                <GridItem3>
                    <RetiradaAnual
                        item={item}
                        ind={ind}
                        handleChange={handleChange}
                    />
                </GridItem3>
            </GridContainer>

            <GridContainer>
                <GridItem3/>
                <GridItem8>
                    <Observacao
                        item={item}
                        ind={ind}
                        handleChange={handleChange}
                    />
                </GridItem8>
            </GridContainer>
        </>
    )
}

export default SimulacaoFinanceiraFormAporteRetiradaAnualConfiguracao